export default "__VITE_PUBLIC_ASSET__f2ce2a5f__"